<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img fluid :src="sideImg" />
        </b-link>

        <b-card-title class="mb-1">
          กรุณาใส่รหัสยืนยันตัวตน
        </b-card-title>
        <b-card-text class="mb-2">
          รหัสยืนยันตัวตนจะถูกส่งไปทาง SMS ที่
          {{ phone }}
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent="login"
          >
            <div class="d-flex justify-content-center my-3">
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                separator="-"
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-complete="handleOnComplete"
              />
            </div>

            <!-- submit button -->
            <b-button variant="primary" block type="submit">
              ยืนยัน
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <b-link @click="resend">
            <feather-icon icon="RepeatIcon" /> Resend
          </b-link>
        </b-card-text>
      </b-card>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import {
  BCard,
  BLink,
  BCardText,
  BCardTitle,
  BForm,
  BButton,
  BImg,
} from "bootstrap-vue";
import { onUnmounted } from "@vue/composition-api";
// eslint-disable-next-line import/no-cycle
import router from "@/router";
import store from "@/store/index";
import authenStoreModule from "./authenStoreModule";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

export default {
  components: {
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BButton,
    BForm,
    BImg,
    ValidationObserver,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: require("@/assets/images/logo/logo.png"),
      phone: router.currentRoute.params.phone,
      otp: 0,
    };
  },
  setup() {
    // Register module
    if (!store.hasModule("authen"))
      store.registerModule("authen", authenStoreModule);

    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule('authen')) store.unregisterModule('authen')
    // })

    return {};
  },
  mounted() {
    this.resend();
  },
  methods: {
    resend() {
      this.$refs.otpInput.clearInput();

      const registerModel = { phone: this.phone };

      store
        .dispatch("authen/verifyPhoneFor", registerModel)
        .then((response) => {
          if (response.status === 200) {
            console.log("response register phone", response);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    login() {
      const userModel = {
        phone: this.phone,
        code: this.otp,
        rememberMe: true,
      };

      store
        .dispatch("authen/loginSms", userModel)
        .then((response) => {
          if (response.status === 200) {
            this.$router.push({
              name: "auth-loginfor",
              params: {
                username: response.data.data.name,
                token: response.data.data.token,
                phone: this.phone,
                otp: this.otp,
              },
            });
          }
        })
        .catch((error) => {
          // this.$refs.loginForm.setErrors(error.response.data.error);
        });
    },
    handleOnComplete(value) {
      this.otp = value;
      this.login();
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.verifyPhone();
        }
      });
    },
    verifyPhone() {
      const registerModel = { phone: this.phone, captcha: this.otp };

      store
        .dispatch("authen/verifyPhone", registerModel)
        .then((response) => {
          if (response.status === 200) {
            console.log("response verify phone", response);

            this.$router.push({
              name: "auth-register",
              params: { phone: this.phone },
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.otp-input {
  width: 45px;
  height: 45px;
  padding: 5px;
  margin: 0 5px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
